import { reduxForm } from 'redux-form';
import PdfDownloadModal from '../components/PdfDownloadModal';

const PdfDownloadForm = reduxForm({
  form: 'PddDownloadDorm'
})(PdfDownloadModal);

export default PdfDownloadForm;
